import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { useFeatureToggles } from '@hooks/useFeatureToggles';
import { getFeatureToggleCookie } from '@helpers/getFeatureSwitchCookie';

const ToggleContext = createContext({});

export const FeatureToggleProvider = ({ children }) => {
  const toggles = useFeatureToggles();

  return <ToggleContext.Provider value={toggles}>{children}</ToggleContext.Provider>;
};

export const useToggle = (toggleName) => {
  const toggles = useContext(ToggleContext);
  const toggle = toggles.find((t) => t.elements.feature.value === toggleName);
  if (!toggle) return false;

  const cohorts = toggle.elements?.cohort?.value || [];
  if (cohorts.length === 0) return false;

  const individualCohort = cohorts.find((cohortItem) => cohortItem?.codename === 'individual');
  const groupCohort = cohorts.find((cohortItem) => cohortItem?.codename === 'everyone');

  // Helper to check individual cohort match
  const isIndividualMatch = () => {
    if (!individualCohort) return false;
    const { id, key } = getFeatureToggleCookie() || {};
    if (!id || !key) return false;
    // Check both id and key match
    return id === toggleName && key === 'display';
  };

  // Helper to check group cohort
  const isGroupEnabled = () => {
    if (!groupCohort) return false;
    return groupCohort?.codename === 'everyone';
  };

  // Decision logic: individual cohort overrides group cohort
  if (individualCohort) {
    if (isIndividualMatch()) return true;
    // If individual cohort exists but does not match, do NOT show feature
    return false;
  }
  // Only group cohort present
  if (groupCohort) {
    return isGroupEnabled();
  }

  return false;
};

FeatureToggleProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
